import { Axios } from 'utils'
import { TWheatCode, TWheatCodeStatus } from 'types/models'
import { TAttribute } from 'types/models/Attribute'
import { IFilterParams } from '../types/models/FilterSort'
import {
  ItemResponseType,
  ListPaginationParams,
  ListResponseType,
} from './types'

export const useWheatCodesService = () => {
  const createWheatCode = async (params: TWheatCode) => {
    try {
      const response = await Axios.post<ItemResponseType<TWheatCode>>(
        '/wheat_codes',
        params
      )
      return response.data
    } catch (error: unknown) {
      throw error
    }
  }

  const updateWheatCode = async (params: TWheatCode) => {
    try {
      const response = await Axios.put<ItemResponseType<TWheatCode>>(
        `/wheat_codes/${params.id}`,
        params
      )
      return response.data
    } catch (error: unknown) {
      throw error
    }
  }

  const getWheatCodes = async (
    filter_params?: IFilterParams,
    pagination?: ListPaginationParams
  ) => {
    try {
      const response = await Axios.post<ListResponseType<TWheatCode>>(
        '/wheat_codes/filters',
        { filter_params: filter_params },
        {
          params: pagination
            ? {
                offset: pagination.currentPage * pagination.itemsPerPage,
                limit: pagination.itemsPerPage,
              }
            : undefined,
        }
      )
      return response.data
    } catch (error: unknown) {
      throw error
    }
  }

  const getWheatCodeStatuses = async () => {
    try {
      const response = await Axios.get<ListResponseType<TWheatCodeStatus>>(
        '/wheat_codes/statuses'
      )
      return response.data
    } catch (error: unknown) {
      throw error
    }
  }

  const getWheatCodeAttributes = async () => {
    try {
      const response = await Axios.get<ListResponseType<TAttribute>>(
        '/wheat_codes/attributes'
      )
      return response.data
    } catch (error: unknown) {
      throw error
    }
  }

  const getWheatCodeById = async (id: string) => {
    try {
      const response = await Axios.get<TWheatCode>(`/wheat_codes/{pk}/${id}`)
      return response.data
    } catch (error: unknown) {
      throw error
    }
  }

  const deleteWheatCode = async (id: number) => {
    try {
      const response = await Axios.delete<{ status: boolean; detail: string }>(
        `/wheat_codes/${id}`
      )
      return response.data
    } catch (error: unknown) {
      throw error
    }
  }

  return {
    createWheatCode,
    updateWheatCode,
    getWheatCodes,
    getWheatCodeAttributes,
    getWheatCodeById,
    deleteWheatCode,
    getWheatCodeStatuses,
  }
}
